module.exports = __webpack_public_path__ + "img/banner-3-3@2x.21ea7ddd.jpg";